// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"LogicBuilderPage":"e0bf06465f7368d98cf7","LegacyViewBuilderPage":"926577cc7ff1c0d5f005","AppDetailsPage":"9af397d682fdbb61dde4","CreateOrganizationUserPage":"631c29141efb61d38c18","ResellerDetailsPage":"a36bfbdbf5aa44ecbd02"}[chunkId] + ".css";
};